import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { fromPrice, hasRange } from '../../utils/products';
import type { Product } from '../../types/product';
import { Stars } from './Stars';
const badgeLabel: Record<string, string> = {
  bestseller: 'Bestseller',
  nieuw: 'Nieuw',
  cadeau: 'Cadeau'
};
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    add
  } = useCart();
  const first = product.variants[0];
  const badge = product.badges[0];
  return <article className="group relative flex h-full flex-col" data-id="element-351" data-mp="272ravkcxvljt">
      <div className="relative overflow-hidden rounded-3xl bg-surface" data-id="element-352" data-mp="223erj9la0wlz">
        <Link to={`/product/${product.slug}`} data-id="element-353" data-mp="2247ndfip61pc">
          <img src={product.image} alt={`${product.name} – ${product.subtitle}`} loading="lazy" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-354" data-mp="cnyjxyn03iy7" />
          {product.gallery[1] && <img src={product.gallery[1]} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_30%] opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" data-id="element-355" data-mp="3lqa39ihdvu29" />}
        </Link>
        {badge && <span className="absolute left-3 top-3 z-10 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-ink" data-id="element-356" data-mp="3dvdu77wwnc3">
            {badgeLabel[badge]}
          </span>}
        <button type="button" onClick={() => add(product.slug, first.id)} className="absolute bottom-3 right-3 z-10 grid h-11 w-11 place-items-center rounded-full bg-white text-ink shadow-[0_6px_16px_-8px_rgba(28,23,20,0.5)] transition-[background-color,color,transform] duration-150 hover:bg-ink hover:text-white active:scale-95" aria-label={`${product.name} (${first.label}) toevoegen aan winkelwagen`} data-id="element-357" data-mp="dbjbp60teayh">
          <PlusIcon className="h-4 w-4" data-id="element-358" data-mp="2c1jqaq7r5yaq" />
        </button>
      </div>
      <div className="flex flex-1 flex-col pt-4" data-id="element-359" data-mp="272qb8tcthz8g">
        <Stars rating={product.rating} reviews={product.reviews} data-id="element-360" data-mp="274b9asycc0b2" />
        <h3 className="mt-2 text-base font-semibold tracking-tight text-ink" data-id="element-361" data-mp="2lzzd4gzqylef">
          <Link to={`/product/${product.slug}`} className="hover:underline hover:underline-offset-4" data-id="element-362" data-mp="2gzv050y1s8sy">
            {product.name}
          </Link>
        </h3>
        <p className="mt-0.5 text-sm text-muted" data-id="element-363" data-mp="2uxjfjt9cinqm">{product.subtitle}</p>
        <p className="mt-auto pt-3 text-base font-semibold text-ink" data-id="element-364" data-mp="2q0j5z8daf2ur">
          {hasRange(product) && <span className="mr-1 text-sm font-normal text-muted" data-id="element-365" data-mp="34p5xs9k3pn2v">vanaf</span>}
          {formatPrice(fromPrice(product))}
          {first.compareAt && <span className="ml-2 text-sm font-normal text-muted line-through" data-id="element-366" data-mp="3dpvowzyf2pa9">{formatPrice(first.compareAt)}</span>}
        </p>
      </div>
    </article>;
}